import { BlockEmbed } from 'quill/blots/block';
import type { Range } from 'quill/core';
import QuillInput from 'quill/modules/input';

// @ts-expect-error
class Input extends QuillInput {
  replaceText(range: Range, text: string) {
    if (range.length === 1) {
      const leaf = this.quill.getLeaf(range.index)[0];
      if (leaf instanceof BlockEmbed) {
        return false;
      }
    }

    // @ts-expect-error
    return super.replaceText(range, text);
  }
}

export default Input;
